/**
 * Navigation
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import smoothscroll from 'smoothscroll-polyfill';
import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.navigation',


	events: {
		'click .navigation__mobile__burger': 'onClickBurger',
		'click a.js-menu-item-scroll': 'onClickMenuItem',
		'click .navigation__mobile .begin-vde': 'onClickVdeMobile',
		'click .navigation__desktop .begin-vde': 'onClickVdeDesktop',
	},

	initialize() {
		window.addEventListener('resize', this.onResize.bind(this));
		/* If we want to keep smooth scrolling on ios etc, keep this */
		smoothscroll.polyfill();
	},

	scrollElementIntoView(element) {
		const navH = document.querySelector(".utility__menu").clientHeight + document.querySelector(".navigation").clientHeight;
		const bodyOffset = (window.innerWidth >= 768) ? navH : element.classList.contains("hero__bottom-area") ? 120 : 60;
		const elementPosition = element.getBoundingClientRect().top,
			offsetPosition = (window.pageYOffset + elementPosition) - bodyOffset;

		setTimeout(() => {
			window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
		}, 0);
	},

	closeBurger() {
		document.getElementById("lpMobileMenuState").checked = false;
		document.body.classList.remove('no-scroll');
	},

	onClickBurger() {
		document.body.classList.toggle('no-scroll');
	},

	onClickMenuItem(e) {
		e.preventDefault();
		if (e.delegateTarget.classList.contains('navigation__mobile__menu__nav__menu-item')) {
			this.closeBurger();
		}

		/* If we want to keep smooth scrolling, keep this */
		const target = e.target.hash;
		const element = document.getElementById(target.substr(1));
		if (!element) return;
		this.scrollElementIntoView(element);
	},

	onClickVdeMobile(e) {
		if (e.delegateTarget.dataset.hubspotdata) {
			e.preventDefault();			
			this.closeBurger();
			
				const hubSpot = JSON.parse(e.delegateTarget.dataset.hubspotdata);
				App.modal.create({
					type: 'generic-signup-modal',
					model: {
						hubSpot,
					},
				});
			
		}
	},

	onClickVdeDesktop(e) {

		if (e.delegateTarget.dataset.hubspotdata) {
			e.preventDefault();

			//Block body scroll when modal is opened
			const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
			const body = document.body;
			body.style.position = 'fixed';
			body.style.top = `-${scrollY}`;

		}
	},

	onResize() {
		if (window.innerWidth >= 768) {
			this.el.classList.remove('open');
			document.body.classList.remove('no-scroll');
		}
	},
});

export default View;